var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isRetina } from '@browsing/utils';
import { IMAGES_WIDTH, DimensionsToWidth } from '../constants';
export var getUrlWithWidth = function (url, width) {
    if (width === void 0) { width = 0; }
    if (!url) {
        return '';
    }
    var density = isRetina() ? 2 : 1;
    return width > 0 ? "".concat(url, "?imwidth=").concat(width, "&imdensity=").concat(density) : url;
};
export var getBannerDesktopImage = function (tab, options) {
    var _a, _b, _c, _d;
    if (options === void 0) { options = {}; }
    if ((_b = (_a = tab === null || tab === void 0 ? void 0 : tab.thb) === null || _a === void 0 ? void 0 : _a.horizontalMedia) === null || _b === void 0 ? void 0 : _b.url) {
        return __assign(__assign({}, tab.thb.horizontalMedia), { altText: tab.thb.horizontalMedia.altText || tab.thb.text, url: getUrlWithWidth(tab.thb.horizontalMedia.url, IMAGES_WIDTH.DESKTOP_BANNER) });
    }
    if (!((_c = tab === null || tab === void 0 ? void 0 : tab.thb) === null || _c === void 0 ? void 0 : _c.horizontalImage)) {
        return {
            mediaType: 'IMAGE',
            altText: ((_d = tab === null || tab === void 0 ? void 0 : tab.thb) === null || _d === void 0 ? void 0 : _d.text) || (tab === null || tab === void 0 ? void 0 : tab.name) || '',
            url: '',
        };
    }
    var url = getUrlWithWidth(tab.thb.horizontalImage, options.omitQueryParams ? 0 : IMAGES_WIDTH.DESKTOP_BANNER);
    return {
        mediaType: 'IMAGE',
        altText: tab.thb.text,
        url: url,
    };
};
export var getBannerMobileImage = function (tab, options) {
    var _a, _b, _c, _d;
    if (options === void 0) { options = {}; }
    if ((_b = (_a = tab === null || tab === void 0 ? void 0 : tab.thb) === null || _a === void 0 ? void 0 : _a.verticalMedia) === null || _b === void 0 ? void 0 : _b.url) {
        return __assign(__assign({}, tab.thb.verticalMedia), { altText: tab.thb.verticalMedia.altText || tab.thb.text, url: getUrlWithWidth(tab.thb.verticalMedia.url, IMAGES_WIDTH.MOBILE) });
    }
    if (!((_c = tab === null || tab === void 0 ? void 0 : tab.thb) === null || _c === void 0 ? void 0 : _c.verticalImage)) {
        return {
            mediaType: 'IMAGE',
            altText: ((_d = tab === null || tab === void 0 ? void 0 : tab.thb) === null || _d === void 0 ? void 0 : _d.text) || (tab === null || tab === void 0 ? void 0 : tab.name) || '',
            url: '',
        };
    }
    var url = getUrlWithWidth(tab.thb.verticalImage, options.omitQueryParams ? 0 : IMAGES_WIDTH.MOBILE);
    return {
        mediaType: 'IMAGE',
        altText: tab.thb.text,
        url: url,
    };
};
var createCampaignImageGetter = function (type, width) {
    return function (campaign, options) {
        var _a, _b, _c;
        if (options === void 0) { options = {}; }
        if ((_b = (_a = campaign === null || campaign === void 0 ? void 0 : campaign.media) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b.url) {
            return __assign(__assign({}, campaign.media[type]), { altText: campaign.media[type].altText || campaign.name, url: getUrlWithWidth(campaign.media[type].url, options.omitQueryParams ? 0 : width) });
        }
        if (!((_c = campaign === null || campaign === void 0 ? void 0 : campaign.images) === null || _c === void 0 ? void 0 : _c[type])) {
            return {
                mediaType: 'IMAGE',
                altText: campaign === null || campaign === void 0 ? void 0 : campaign.name,
                url: '',
            };
        }
        var url = getUrlWithWidth(campaign.images[type], options.omitQueryParams ? 0 : width);
        return {
            mediaType: 'IMAGE',
            altText: campaign.name,
            url: url,
        };
    };
};
export var getCampaignLogoImage = createCampaignImageGetter('logo');
export var getCampaignMobileImage = createCampaignImageGetter('mobile', IMAGES_WIDTH.MOBILE);
export var getCampaignMoodImage = createCampaignImageGetter('mood');
export var getCampaignUpcomingImage = createCampaignImageGetter('upcoming');
export var getCampaignImage = function (campaign, aspectRatio, options) {
    var _a;
    if (options === void 0) { options = {}; }
    if (!aspectRatio) {
        return getCampaignMobileImage(campaign, options);
    }
    if (campaign === null || campaign === void 0 ? void 0 : campaign.media) {
        var aspectRatioMedia = campaign.media["campaigns".concat(aspectRatio)];
        if (aspectRatioMedia && aspectRatioMedia.url) {
            return __assign(__assign({}, aspectRatioMedia), { altText: aspectRatioMedia.altText || campaign.name, url: getUrlWithWidth(aspectRatioMedia.url, options.omitQueryParams ? 0 : DimensionsToWidth[aspectRatio]) });
        }
    }
    if (!((_a = campaign === null || campaign === void 0 ? void 0 : campaign.images) === null || _a === void 0 ? void 0 : _a.campaigns)) {
        return {
            mediaType: 'IMAGE',
            altText: campaign === null || campaign === void 0 ? void 0 : campaign.name,
            url: '',
        };
    }
    var aspectRatioImage = campaign.images.campaigns.find(function (img) { return (img === null || img === void 0 ? void 0 : img.aspectRatio) === aspectRatio; });
    if (!aspectRatioImage) {
        return {
            mediaType: 'IMAGE',
            altText: campaign === null || campaign === void 0 ? void 0 : campaign.name,
            url: '',
        };
    }
    var url = getUrlWithWidth(aspectRatioImage.url, options.omitQueryParams ? 0 : DimensionsToWidth[aspectRatio]);
    return {
        mediaType: 'IMAGE',
        altText: campaign.name,
        url: url,
    };
};
